<template>
  <div class="orderContent shopOrder">
    <header class="pageHeader">
      <div class="hBtnl" @click="gotoBack()">
        <button class="btnDiv btnDivd btnDivn">
          <i class="iconfont">&#xe601;</i>
        </button>
      </div>
      <h1 v-if="type == 'shop'" class="pageHeader-title">商城订单</h1>
      <h1 v-if="type == 'rented'" class="pageHeader-title">盆花租摆</h1>
      <h1 v-if="type == 'replace'" class="pageHeader-title">代客祭扫</h1>
      <h1 v-if="type == 'subscribe'" class="pageHeader-title">预定服务</h1>
      <h1 v-if="type == 'maintain'" class="pageHeader-title">维护费</h1>
      <div class="hBtnr">
        <button class="btnDiv btnDivd btnDivn">
          <!---->
          <label class="btnDiv-text"></label>
        </button>
      </div>
    </header>
    <div v-if="list.length == 0" class="noData">
      <p v-if="type == 'shop'">暂无商城订单~</p>
      <p v-if="type == 'rented'">暂无盆花租摆订单~</p>
      <p v-if="type == 'replace'">暂无代客祭扫订单~</p>
      <p v-if="type == 'subscribe'">暂无预定服务订单~</p>
      <p v-if="type == 'maintain'">暂无维护费订单~</p>
    </div>
    <div v-else>
      <div class="orders" v-for="(item, index) in list" :key="index">
        <div class="title" @click="goOrder(item.orderNo)">
          <span class="order">订单号 : {{ item.orderNo }}</span>
          <span class="status"> {{ $properties(item.payStatus, 'label') }}</span>
          <img src="../../../assets/li.svg" class="line" />
        </div>
        <!-- 商城订单 -->
        <template v-if="type == 'shop'">
          <div class="shop" v-for="(item2, index2) in item['goodsList']" :key="index2">
            <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- 盆花租摆 -->
        <template v-if="type == 'rented'">
          <div class="shop" v-for="(item2, index2) in item['goodsList']" :key="index2">
            <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- 代客祭扫 -->
        <template v-if="type == 'replace'">
          <div class="shop" v-for="(item2, index2) in item['goodsList']" :key="index2">
            <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- 预订服务  -->
        <template v-if="type == 'subscribe'">
          <div class="shop" v-for="(item2, index2) in item['goodsList']" :key="index2">
            <img :src="item2.firstPhoto" class="pic2" />
            <div class="info">
              <span class="name">{{ item2.proName }}</span> <br />
              <span class="size">规格: {{ item2.specification.name }}</span> <br />
              <span class="money">￥{{ item2.price }}</span>
              <span class="num">× {{ item2.count }}</span>
            </div>
            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <!-- 维护费订单 -->
        <template v-if="type == 'maintain'">
          <div v-for="(item2, index2) in item['maintainList']" :key="index2">
            <!-- 维护费的这个图片，采用固定图片，后台可以修改 -->
            <div class="maintain">
              <span class="name">缴纳维护费</span> <br />
              <!-- name 固定 size 只更改年限-->
              <span class="size">规格: {{ item2.duration }}年维护费</span> <br />
              <span class="money">￥{{ item2.price }}</span>
            </div>

            <img src="../../../assets/li.svg" class="line" />
          </div>
        </template>
        <div class="bottom">
          <span>总计：￥{{ item.amount }}</span>
          <ul v-if="$properties(item.payStatus, 'value') == '2'">
            <li><div class="pay" @click="goPay(item.orderNo)">去支付</div></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order',
  data() {
    return {
      count: 0,
      isLoading: false,
      type: '',
      pageName: '',
      list: [],
      total: 0,
    }
  },

  created() {
    this.type = this.$route.params.type
    this.pageName = this.$route.params.type
    this.queryOrderPage(this.type)
  },
  mounted() {},
  methods: {
    queryOrderPage(type) {
      var that = this
      this.$queryPage(
        '/api/order/queryOrderPage',
        {
          myId: this.$store.getters.userId,
          orderType: type,
          sort: { payStatus: 'desc' },
        },
        function(res) {
          that.$fill(that.list, res['data'])
          that.total = res['total']
        }
      )
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.count++
      }, 1000)
    },
    goOrder(orderNo) {
      this.$router.push({ path: '/shop/orders/' + this.pageName + '/' + orderNo })
    },
    goPay(orderNo) {
      this.$router.push({ path: '/shop/payok', query: { orderNo: orderNo } })
    },
    gotoBack() {
      this.$router.push({ path: '/my' })
    },
  },
  watch: {},
}
</script>

<style>
.shopOrder .orders {
  width: 35.5rem;
  height: auto;
  background-color: #fff;
  margin-top: 1rem;
  margin-left: 2rem;
  padding-left: 1.5rem;
  padding-top: 1.5rem;
  position: relative;
  top: 0;
  left: -1rem;
}
.shopOrder .orders .maintain {
  line-height: 2.5rem;
  font-size: 1.4rem;
}
.shopOrder .orders .title {
  height: 5rem;
  width: 35.5rem;
  font-size: 1.4rem;
  margin-top: -1.5rem;
  margin-left: -1.5rem;
  padding-left: 1.7rem;
  padding-top: 1.5rem;
}
.shopOrder .orders .title .status {
  float: right;
  margin-right: 1rem;
  font-size: 1.4rem;
}
.shopOrder .orders .title .line1 {
  position: relative;
  left: -1.5rem;
  top: -0.5rem;
  width: 35.5rem;
}
.shopOrder .orders .shop {
  width: 35.5rem;
  height: 9.1rem;
  margin: 0.5rem 0 1rem;
}
.shopOrder .orders .shop .pic2 {
  width: 8rem;
  height: 8rem;
}
.orderContent .shop .info {
  width: 22.15rem;
  height: 7.6rem;
  position: relative;
  left: 9rem;
  top: -8.2rem;
}
.orderContent .shop .info .name {
  font-size: 1.4rem;
}
.orderContent .shop .info .size {
  color: #999;
  font-size: 1.2rem;
  position: relative;
  top: 1rem;
}
.orderContent .shop .info .money {
  color: #15a892;
  font-size: 1.6rem;
  position: relative;
  top: 1.5rem;
}

.orderContent .shop .info .num {
  float: right;
  margin-right: -1.4rem;
  font-size: 1.4rem;
}
.shopOrder .orders .shop .line {
  position: relative;
  top: -8rem;
  left: -1.5rem;
}

.shopOrder .orders .line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.shopOrder .orders .bottom {
  width: 32.9rem;
  height: 4rem;
  padding-top: 0.8rem;
}
.shopOrder .orders .bottom span {
  font-size: 1.4rem;
}
.shopOrder .orders .bottom .pay {
  background-color: #15a892;
  color: #fff;
}
.shopOrder .orders .bottom ul li .pay {
  left: 1.2rem;
}
.shopOrder .orders .bottom ul li div {
  width: 8rem;
  height: 3rem;
  border: 0.1rem solid #eee;
  font-size: 1.3rem;
  list-style: none;
  float: right;
  position: relative;
  left: 11.8rem;
  top: -2.5rem;
  margin-right: 1rem;
  padding-top: 0.6rem;
  text-align: center;
}

.shopOrder .pageHeader {
  background-color: #fff;
  color: #333;
  -ms-flex-align: center;
  align-items: center;

  box-sizing: border-box;

  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  height: 40px;
  line-height: 1;
  padding: 0 10px;
  position: relative;
  text-align: center;
  white-space: nowrap;
}

.shopOrder .hBtnl {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: left;
}
.shopOrder .hBtnr {
  -ms-flex: 0.5;
  flex: 0.5;
  text-align: right;
}
.shopOrder .pageHeader .pageHeader-title {
  font-size: 18px;
}
.shopOrder .pageHeader-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
  font-weight: 400;
  -ms-flex: 1;
  flex: 1;
}

.shopOrder .hBtn {
  -ms-flex: 0.5;
  flex: 0.5;
}
.shopOrder .pageHeader .btnDiv {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: inherit;
  display: inline-block;
  padding: 0;
  font-size: inherit;
}
.shopOrder .btnDivn,
.shopOrder .btnDivs {
  display: inline-block;
  padding: 0 12px;
}
.shopOrder .btnDivd {
  color: #656b79;
  background-color: #f6f8fa;
  box-shadow: 0 0 1px #b8bbbf;
}
.shopOrder .noData {
  width: 20rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.shopOrder .show {
  display: block !important;
}
.shopOrder .noData:before {
  width: 100%;
  height: 9.5rem;
  display: block;
  content: '';
  background: url(../../../assets/noData.png) 50% no-repeat;
  background-size: contain;
}

.shopOrder .noData p {
  font-size: 1.4rem;
  color: #999;
  text-align: center;
  height: 2.4rem;
  line-height: 2.4rem;
  margin-top: 1.4rem;
}
</style>
